import {
  ENTRY_DATA_SECTION_KEYS as SECTION_KEYS,
  ENTRY_DATA_INVESTORS_GROUP_TABLE_KEY as INVESTORS,
  ENTRY_DATA_INVESTORS_SHELL_KEYS as INVESTORS_SHELL_KEYS,
} from "@frontend/common";

import { ArticleEntryData } from "@/types/articleEntryData.types";
import { EntryDataInvestorValue } from "@/types/ventureCapital.types";
import { useTableCreatorFocusStatus } from "@FillInTableContainer/shared/context/TableCreatorFocusStatusContext";
import { useEntryDataState } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

const sectionKey = SECTION_KEYS.ventureCapital;
const groupTableKey = INVESTORS;
const shellKey = INVESTORS_SHELL_KEYS.investorName;
export const useInvestorTableValueClear = () => {
  const [entryData, setEntryData] = useEntryDataState(getPressIdFromURL());
  const { changeFocusStatus } = useTableCreatorFocusStatus();

  const clearInvestorTableValue = (valueIndex: number) => {
    const valueLength =
      entryData?.[sectionKey]?.[groupTableKey]?.[shellKey]?.value?.length || 0;
    const updatedEntryData = {
      ...entryData,
      [sectionKey]: {
        ...entryData[sectionKey],
        [groupTableKey]: {
          ...entryData?.[sectionKey]?.[groupTableKey],
          [shellKey]: {
            ...entryData?.[sectionKey]?.[groupTableKey]?.[shellKey],
            value: entryData?.[sectionKey]?.[groupTableKey]?.[
              shellKey
            ]?.value?.map((value, index) =>
              index === valueIndex
                ? {
                    ...value,
                    text: "",
                    is_lead_investor: false,
                  }
                : value,
            ) as EntryDataInvestorValue[],
          },
        },
      },
    };

    setEntryData(updatedEntryData as ArticleEntryData);
    if (valueLength < 2) {
      changeFocusStatus({ type: "default", container: "noFocus" });
      return;
    }
    changeFocusStatus({ type: "delete", container: "value" });
  };

  return { clearInvestorTableValue };
};
